import { render, staticRenderFns } from "./EditEmailTemplate.vue?vue&type=template&id=56145558&"
import script from "./EditEmailTemplate.vue?vue&type=script&lang=js&"
export * from "./EditEmailTemplate.vue?vue&type=script&lang=js&"
import style0 from "./EditEmailTemplate.vue?vue&type=style&index=0&id=56145558&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports